export const resetSignUpBrandingColors = (): void => {
  const brandingProperties = [
    '--color-primary-rgb',
    '--primary',
    '--color-primary-50',
    '--color-primary-100',
    '--color-primary-200',
    '--color-primary-700',
  ];

  brandingProperties.forEach((property) => document.documentElement.style.removeProperty(property));
};
